var module; UMD(module, {
  "minted:m": ["M"],
})(this, function (m_module) {
  function getTrackedUrl(url, component, app) {
    app = app || '*';
    var queryParam = 'mntd_prf=' + app + ':' + component;
    var prefix = '?';
    if (url.match(/\?/)) {
      prefix = '&';
    }
    var trackedUrl = url + prefix + queryParam;
    return trackedUrl;
  }

  function track(params) {
    var elapsedTime = window.performance.now();
    var timestamp = Date.now();

    if (window.mintedAnalyticsTag) {
      params = params || {};
      params.app = params.app || '*';
      params.creationTime = params.creationTime || 0;

      var duration = elapsedTime - params.creationTime;
      if (params.creationTime === 0) {
        duration = 0;
      }

      window.mintedAnalyticsTag.track({
        app: params.app,
        component: params.component,
        name: params.name || 'mounted',
        elapsedTime: elapsedTime,
        duration: duration,
        timestamp: timestamp
      });
    }
  }

  var M = m_module.M;
  M.MintedAnalytics = M.MintedAnalytics || {};
  M.MintedAnalytics.track = M.MintedAnalytics.track || track;
  M.MintedAnalytics.getTrackedUrl = M.MintedAnalytics.getTrackedUrl || getTrackedUrl;

  return { track: track };
});
